module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-7dc19a53939dc2fd716128cf198c97fa.svg&quot;;"